import { render } from "./CallEnd.vue?vue&type=template&id=32b7748c&scoped=true&ts=true"
import script from "./CallEnd.vue?vue&type=script&lang=ts"
export * from "./CallEnd.vue?vue&type=script&lang=ts"

import "./CallEnd.vue?vue&type=style&index=0&id=32b7748c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b7748c"]])

export default __exports__